export type TripState = 'Draft' | 'Scheduled' | 'Complete'

export type TripStatusBadge = 'draft' | 'scheduled' | 'complete'

export type TripLifecycleStatus = 'draft' | 'scheduled' | 'complete'

export function toStatusBadge(state: TripState): TripStatusBadge {
  const map: Record<TripState, TripStatusBadge> = {
    Draft: 'draft',
    Scheduled: 'scheduled',
    Complete: 'complete',
  }
  return map[state]
}

export function toLifecycleStatus(state: TripState): TripLifecycleStatus {
  const map: Record<TripState, TripLifecycleStatus> = {
    Draft: 'draft',
    Scheduled: 'scheduled',
    Complete: 'complete',
  }
  return map[state]
}

export function isTripEditable(state: TripState): boolean {
  return state === 'Draft' || state === 'Scheduled'
}
